<template>
    <div class="form-vacancy" v-if="form != null">
        <!-- {{options}} -->
        <form class="form_call">
            <div class="form-in" v-if="formVisible">
                <div class="form-group form-text">
                    <label for="name">{{form.name_label}}</label>
                    <input type="text" name="name" class="form-control" :placeholder="form.name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                </div>
                <div class="form-group form-phone">
                    <label for="phone">{{form.phone_label}}</label>
                    <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" :placeholder="form.phone_mask" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                </div>
                <div class="form-group form-mail">
                    <label for="email">{{form.email_label}}</label>
                    <input type="text" name="email" class="form-control"  :placeholder="form.email_mask" v-model="mail">
                </div>
                <div class="form-group form-addfile">
                    <label for="phone">Прикрепить резюме</label>
                    <div class="fileUpload" v-if="this.vac_file == null">
                        <span>ВЫБРАТЬ ФАЙЛ</span>
                        <input type="file" multiple 
                            accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf,.zip,.rar,.7zip"
                            @change="FileUpload($event)"
                        >
                    </div>
                    <div class="uploadComplete" v-else>
                        <span>Файл добавлен</span>
                    </div>
                </div>
                <div class="btn-send">
                    <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">Отправить</button>
                    <span class="error-message" v-show="errors.has('name') || errors.has('phone') || errors.has('email')">Заполните все поля</span>
                    <span class="error-message" v-if="errorMsgFile">Загрузите резюме</span>
                </div>
            </div>
            <div class="successMessage" v-if="!formVisible">
                <h3>Спасибо! Ваше резюме отправлено.</h3>
            </div>
        </form>
    </div>
</template>

<script>
    import firebase from 'firebase'
    import MaskedInput from 'vue-masked-input'
    import {mapGetters} from 'vuex'
    import { Validator } from 'vee-validate';
    const dict = {
        custom: {
            email: {
                required: () => 'Введите ваш E-mail'
            },
            name: {
                required: () => 'Введите ваше имя'
            },
            phone: {
                required: () => 'Введите ваш номер телефона'
            }
        }
    };
    Validator.localize('ru', dict);
    export default {
        name: 'FormConsult',
        props: ['options'],
        data () {
            return {
                phone: '',
                name: '',
                mail: '',
                admin_mail: '',
                vac_file: null,
                typeFile: null,
                sizeFile: null,
                agree: false,
                formVisible: true,
                errorMsg: false,
                errorMsgFile: false,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                    mail: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
            MaskedInput,
        },
        computed: mapGetters({
            form: 'loadForms',
        }),
        methods: {
            sendData() {
                var _self = this;
                var querystring = require('querystring');
                var data = {
                    'admin': this.options[0].email,
                    'city': this.options[0].city.name,
                    'title': this.options[0].title,
                    'name': this.name,
                    'phone': this.phone,
                    'mail': this.mail,
                    'url': this.vac_file,
                };
                // console.log(data, 'form consult')
                // console.log(JSON.stringify(data));
                this.$validator.validate().then(result => {
                    if(result) {
                        if (this.vac_file != null) {
                            this.errorMsgFile = false;
                            this.formVisible = false;
                            firebase.storage().ref(ID() + this.typeFile).put(this.vac_file).then(function(snapshot) {
                                // console.log('Uploaded file complete');
                                // console.log(snapshot)
                                snapshot.ref.getDownloadURL().then(function(downloadURL) {
                                    // console.log("File available at", downloadURL);
                                    // console.log(_self.options[0].city.slug, 'asdasdasd')
                                    data.url = downloadURL;
                                    axios.post('/formVacancy.php', querystring.stringify(data));
                                    if (_self.options[0].city.slug == 'almaty') {
                                        $.ajax({
                                            url: "https://docs.google.com/forms/d/e/1FAIpQLSfEGfskpUOGZ8YuRuSzJjWm_wYL1geQSO5wfLclZ8EH5UzI4A/formResponse",
                                            data: {
                                                // city
                                                "entry.1000096898": _self.options[0].city.name,
                                                // vac_name
                                                "entry.329493797": _self.options[0].title,
                                                // name
                                                "entry.1039276133": _self.name,
                                                // phone
                                                "entry.9438842": _self.phone,
                                                // email
                                                "entry.1214134863": _self.mail,
                                                // link
                                                "entry.725664271": data.url,
                                            },
                                            type: "POST",
                                            dataType: "xml"
                                        });
                                    } else if (_self.options[0].city.slug == 'astana') {
                                        // console.log('asdasdasda', _self.options[0].city.slug)
                                        $.ajax({
                                            url: "https://docs.google.com/forms/d/e/1FAIpQLSeAGjOXsav_PK-5h_-0AgQhcRaYAfWAAjNHM5d4_BsIgPKyhg/formResponse",
                                            data: {
                                                // city
                                                "entry.1916313840": _self.options[0].city.name,
                                                // vac_name
                                                "entry.1642610742": _self.options[0].title,
                                                // name
                                                "entry.317008002": _self.name,
                                                // phone
                                                "entry.849900134": _self.phone,
                                                // email
                                                "entry.2098794138": _self.mail,
                                                // link
                                                "entry.1354174436": data.url,
                                            },
                                            type: "POST",
                                            dataType: "xml"
                                        });
                                    } else {
                                        $.ajax({
                                            url: "https://docs.google.com/forms/d/e/1FAIpQLSfXHr0BB7q969xFDyyKmd1EV_gCOc3l7xo7N4l6ay0ZnzAdgA/formResponse",
                                            data: {
                                                // city
                                                "entry.241902956": _self.options[0].city.name,
                                                // vac_name
                                                "entry.85849589": _self.options[0].title,
                                                // name
                                                "entry.406831511": _self.name,
                                                // phone
                                                "entry.547122283": _self.phone,
                                                // email
                                                "entry.1180729585": _self.mail,
                                                // link
                                                "entry.1216385809": data.url,
                                            },
                                            type: "POST",
                                            dataType: "xml"
                                        });
                                    }
                                }).catch(error => {
                                    console.log(error)
                                })    
                            }).catch(error => {
                                console.log(error)
                            });   
                            // console.log(data, 'данные')
                        } else {
                            this.errorMsgFile = true;
                        }
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
                var ID = function () {
                    return '_' + Math.random().toString(36).substr(2, 9);
                };
            },
            FileUpload(event) {
                this.vac_file = event.target.files[0];
                this.typeFile = this.vac_file.name.match(/\.[0-9a-z]+$/i)[0];
                this.sizeFile = this.vac_file.size;
            },
            closeForm() {
                this.$store.commit('Open_form_Consult', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                this.phone = '';
                this.name = '';
                this.mail = '';
                setTimeout(() => {
                    this.formVisible = true;
                }, 600);
            }
        },
        beforeCreate() {
            this.$store.dispatch('getFormsData');
        },
        created () {
        },
        mounted () {
            // this.$store.watch(
            //     (state) => state.forms,
            //     (newValue) => {
            //         if (newValue)
            //         this.admin_mail = this.form.admin_email
            //     }
            // )
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-vacancy.scss';
    @import '@/styles/components/forms/respond/form-vacancy-respond.scss';
    // @import '@/styles/respond/forms/form-consult-respond.scss';
</style>